module.exports = __webpack_public_path__ + "img/CyberArk.e2b3dbb.svg";